<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Clause Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.clseNo }}</td>
            <td class="text-xs-left">{{ props.item.clseTitle }}</td>
            <td class="text-xs-left">{{ props.item.clseTxt }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['cargoRatingReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Clause
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="clauseDialog" width="800px" lazy v-if="checkAccess(['cargoRatingReview'])" persistent >
        <clause-dialog :clauseForm="clauseForm" @close="doClose" :newClause="newClause"></clause-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Clause? ({{deleteClause}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import ClauseDialog from './ClauseDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Clause Code', align: 'left', value: 'clseNo' },
        { text: 'Clause Title', align: 'left', value: 'clseTitle' },
        { text: 'Clause Text', align: 'left', value: 'clseTxt' }
      ],
      clauseForm: {
        clseNo: undefined,
        clseTitle: undefined,
        clseTxt: undefined
      },
      clauseDialog: undefined,
      newClause: undefined,
      loading: false,
      promptRemove: false,
      selectedClause: undefined,
      deleteClause: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.cargo.menu.getClauses
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((Clause) => {
              const convertClause = {
                clseNo: Clause.clseNo,
                clseTitle: Clause.clseTitle,
                clseTxt: Clause.clseTxt
              }
              this.items.push(convertClause)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(Clause) {
      const apiURI = this.$store.state.cargo.menu.getClause
      const expand = {
        clseNo: Clause.item.clseNo
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.clauseForm.clseNo = data.clseNo.clseNo
          this.clauseForm.clseTitle = data.clseNo.clseTitle
          this.clauseForm.clseTxt = data.clseNo.clseTxt
        }
        this.clauseDialog = true
      }
    },
    doClose() {
      this.clauseDialog = false
      this.newClause = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.clauseDialog = true
      this.newClause = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedClause = data
        this.deleteClause = data.clseNo + ' - ' + data.clseTitle
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.cargo.menu.deleteClause
      if (apiURI) {
        this.loading = true
        const expand = {
          clseNo: this.selectedClause.clseNo
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['cargoRatingReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    ClauseDialog: ClauseDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
